export default __webpack_public_path__ + "static/architecture-74dd86bcef4a03b6496e6ea38bf77308.png";